import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=20b0c948&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=js"
export * from "./EventsCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventsCalendar.vue?vue&type=style&index=0&id=20b0c948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0c948",
  null
  
)

export default component.exports